import { Button } from "@mui/material";

interface ContinueBtnProps {
  disabled?: boolean;
  onClick: () => void;
}

const BackBtn = ({ disabled, onClick }: ContinueBtnProps) => {
  return (
    <Button
      variant="outlined"
      disabled={disabled}
      onClick={onClick}
      sx={{
        display: "flex",
        justifyContent: "space-center",
        width: "110px",
        height: "38px",
        fontWeight: "bold",
        borderRadius: "54px",
      }}
    >
      Back
    </Button>
  );
};

export default BackBtn;
